import { render, staticRenderFns } from "./ProjectTeamView.vue?vue&type=template&id=5aa6870d&scoped=true"
import script from "./ProjectTeamView.vue?vue&type=script&lang=js"
export * from "./ProjectTeamView.vue?vue&type=script&lang=js"
import style0 from "./ProjectTeamView.vue?vue&type=style&index=0&id=5aa6870d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa6870d",
  null
  
)

export default component.exports